import Image from 'next/image';
import Link from 'next/link';

import * as S from './styles';

interface HelpItemContainerProps {
  iconSrc: string;
  iconAlt: string;
  title: string;
  description: string;
  href: string;
  imgWidth?: number;
  imgHeight?: number;
}

export const HelpItem: React.FC<HelpItemContainerProps> = ({
  description,
  href,
  iconSrc,
  iconAlt,
  title,
  imgHeight,
  imgWidth,
}) => {
  return (
    <S.HelpItemContainer>
      <div>
        <Image
          src={iconSrc}
          alt={iconAlt}
          width={imgWidth || 32}
          height={imgHeight || 32}
          objectFit="contain"
          loading="lazy"
        />
      </div>

      <h3>{title}</h3>

      <p>{description}</p>

      <a href={href}>Saiba mais</a>
    </S.HelpItemContainer>
  );
};
